import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import Indusone from "../../images/aktcorp/Indus-one.jpeg";
import FirstSlide from "../../components/Section/FirstSlide";
import SearchProducts from "../../components/Section/SearchProducts";

export default function Sectionone() {
  const [bgColor, setBgColor] = useState("transparent");
  return (
    <section className="w-full bg-[#0C2340] text-white">
      <div className="mx-auto px-4 py-3 md:py-0 lg:py-3">
        {/* Top Section - Image & Text */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-3 items-stretch">
          {/* Left Side - Image */}
          <div className="lg:col-span-7 flex">
            <div className="w-full h-[400px] overflow-hidden rounded-lg">
              <img
                src={Indusone}
                alt="Offshore Industry"
                className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-110"
              />
            </div>
          </div>

          {/* Right Side - Text Content */}
          <div className="lg:col-span-5 bg-white text-[#0c2340] p-6 rounded-lg duration-300 ease-in-out flex flex-col justify-center h-[400px]">
            <h2 className="text-2xl md:text-4xl font-bold mb-4">
              GET THE TOOLS AND SUPPLIES YOU NEED FAST, RELIABLE, AND AFFORDABLE!
            </h2>
            <p className="text-base md:text-lg mb-6">
              From industrial equipment to building materials, we have everything you need to power your projects.
              Request your free quote now, and let our experts deliver the best solutions—quickly and hassle-free!
            </p>
            <Link to="/contact-us">
              <button
                className={`px-3 py-2 border-2 border-[#0C2340] text-[#0C2340] hover:text-white font-semibold rounded-lg transition duration-300`}
                style={{ backgroundColor: bgColor }}
                onMouseEnter={() => setBgColor("#1B365D")} // On hover
                onMouseLeave={() => setBgColor("white")} // After hover
              >
                INQUIRE NOW
              </button>
            </Link>
          </div>
        </div>
        <div className="mt-2 text-black">
          <SearchProducts />
        </div>
        {/* First Slide Component */}
        <div className="mt-3">
          <FirstSlide />
        </div>

        {/* Bottom Section - Three Columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-3">
          {/* Box 1 */}
          <div className="bg-white text-[#0C2340] p-6 rounded-lg shadow-lg duration-300 ease-in-out flex flex-col h-[240px]">
            <h3 className="text-[20px] font-bold mb-3 md:text-2xl">REDEFINING TOMORROW</h3>
            <p className="text-base md:text-lg">
              At AKT Corp, we turn ideas into action, forging solutions that redefine industries and improve lives.
              Driven by innovation and purpose, we create a future where possibilities become realities.
            </p>
          </div>

          {/* Box 2 */}
          <div className="bg-[#1B365D] text-white p-6 rounded-lg shadow-lg duration-300 ease-in-out flex flex-col h-[240px]">
            <h3 className="text-2xl font-bold mb-3">OUR SERVICES</h3>
            <p className="text-base md:text-lg">
              AKT Corp works with a concentrated set of leading suppliers bringing the best materials to our client’s
              business needs. We recognize the need to support clients with high-quality products and marketing support.
            </p>
          </div>

          {/* Box 3 */}
          <div className="bg-[#1B365D] text-white p-6 rounded-lg shadow-lg duration-300 ease-in-out flex flex-col h-[240px]">
            <h3 className="text-2xl font-bold mb-3">CONTACT US</h3>
            <p className="text-base md:text-lg">
              Need industrial solutions? Contact us for tailored quotes, expert advice, and fast support.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
